import "./OurWork.css";

import img1 from "../../../Assets/Product_Imgs/akgupta.png";
import img2 from "../../../Assets/Product_Imgs/interior_edited.png";
import img3 from "../../../Assets/Product_Imgs/livio_edited.png";
import img4 from "../../../Assets/Product_Imgs/studentstash.png";
import img5 from "../../../Assets/Product_Imgs/VALUM.jpg";

import { MdArrowBackIosNew } from "react-icons/md";
import { GrNext } from "react-icons/gr";
import { useCallback, useEffect, useState } from "react";

const OurWork = () => {
  const [index, setIndex] = useState(0);

  const arr = [
    {
      img: img5,
      heading: "V-Alum",
      text:
        "V-Alum a specialized alumni portal, designed to unite former and current students on a singular, integrated platform. Beyond being merely a website, V-Alum serves as a venue where alumni can rekindle connections, engage in networking, and maintain active participation within their school community.",
      link: "https://valumn.com/",
    },
    {
      img: img1,
      heading: "AK Gupta Construction Co",
      text:
        "A trusted name in the construction industry. We developed a modern website highlighting projects, expertise, and delivering a seamless user experience that reflects quality and reliability.",
    },
    {
      img: img2,
      heading: "Interior Design Studio",
      text:
        "Interior Design Studio transcends traditional project management—it represents a digital embodiment of creative professionals’ visions. We worked closely with designers to balance inspiration, deadlines, and client collaboration.",
    },
    {
      img: img3,
      heading: "LIVIO",
      text:
        "LIVIO is a bespoke software platform built through deep collaboration, designed to optimize workflows, reduce manual effort, and deliver actionable insights through intuitive dashboards.",
    },
    {
      img: img4,
      heading: "StudentStash Exchange",
      text:
        "StudentStash Exchange streamlines how students share resources, collaborate academically, and build meaningful peer-to-peer connections in a secure digital environment.",
    },
  ];

  const nextSlide = useCallback(() =>
    setIndex((prev) => Math.min(prev + 1, arr.length - 1)), [arr.length]);

  const prevSlide = useCallback(() =>
    setIndex((prev) => Math.max(prev - 1, 0)), []);

  /* Keyboard navigation */
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowRight") nextSlide();
      if (e.key === "ArrowLeft") prevSlide();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [nextSlide, prevSlide]);

  return (
    <section id="products" className="hero_ourWork">
      <h1 className="hero_ourWork_heading">Our Work</h1>

      <div className="work_container">
        <div
          className="slides"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {arr.map((item, ind) => (
            <div className="hero_ourWork_section_body" key={ind}>
              <img
                src={item.img}
                alt={item.heading}
                className="hero_ourWork_photo"
                loading="lazy"
                style={{
                  transform:
                    item.heading === "V-Alum"
                      ? "translateY(-20px)"
                      : "translateY(0)",
                }}
              />

              <div className="hero_ourWork_section_text">
                <p className="hero_ourWork_text">
                  <span className="work_title">{item.heading}</span>
                  {item.text.replace(item.heading, "")}
                </p>

                {/* ACTION ROW */}
                <div className="hero_ourWork_actionRow">
                  {/* Explore button only when link exists */}
                  {item.link && (
                    <button
                      className="hero_section_explore_btn"
                      onClick={() => window.open(item.link, "_blank")}
                    >
                      Explore More
                    </button>
                  )}

                  {/* Inline arrows */}
                  <div className="hero_ourWork_inlineArrows">
                    <button
                      className="hero_ourWork_arrow"
                      onClick={prevSlide}
                      disabled={index === 0}
                      aria-label="Previous Project"
                    >
                      <MdArrowBackIosNew />
                    </button>

                    <button
                      className="hero_ourWork_arrow"
                      onClick={nextSlide}
                      disabled={index === arr.length - 1}
                      aria-label="Next Project"
                    >
                      <GrNext />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurWork;
